import { CircleIcon, QuestionMarkIcon } from '../generated'
import { StackIcons } from '../StackIcons'
import type { PredefinedStackProps } from '../PredefinedStackProps'

export const QuestionMarkIconStacked = ({ backgroundColor, mainColor, color, ...props }: PredefinedStackProps) => (
  <StackIcons variant="full" {...props}>
    <CircleIcon color={backgroundColor || color} />
    <QuestionMarkIcon color={mainColor || color} />
  </StackIcons>
)
